import { groq } from 'next-sanity'

export const imageProjection = groq`{
  ...,
  asset->{
    _type,
    _id,
    url,
    metadata {
      lqip
    }
  }
}
`
